import { z } from "zod";

export const frameworkReviewScopeSchema = z.object({
  frameworkId: z.string().min(1).max(200),
  frameworkVersion: z.string().min(1).max(200),
}).strict();

export type FrameworkReviewScope = z.infer<typeof frameworkReviewScopeSchema>;

/** A request identity, never an arbitrary return URL or a framework-wide queue. */
export const reviewRequestRefSchema = z.object({
  kind: z.enum(["attestation", "scope", "close"]),
  id: z.string().uuid(),
}).strict();
export type ReviewRequestRef = z.infer<typeof reviewRequestRefSchema>;

export function reviewsForFramework<T extends { framework_id: string; framework_version: string }>(
  rows: T[],
  scope: FrameworkReviewScope,
): T[] {
  return rows.filter((row) => row.framework_id === scope.frameworkId && row.framework_version === scope.frameworkVersion);
}
